import React from "react";
import PropTypes from "prop-types";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { IMaskInput } from "react-imask";


const EmailMask = /^\S*@?\S*$/;

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+7 (#00) 000-00-00"
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

const TextMaskCustomEmail = React.forwardRef(function TextMaskCustomEmail(
  props,
  ref
) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={EmailMask}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});


const TextMaskCustomWagonNumber = React.forwardRef(function TextMaskCustomWagonNumber(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="000-00000"
      definitions={{
        "#": /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});


TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

TextMaskCustomEmail.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

TextMaskCustomWagonNumber.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function InputPhoneField(props) {
  //const classes = useStyles();

  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [emailNumber, setEmailNumber] = React.useState("");
  const [wagonNumber, setWagonNumber] = React.useState("");
  const [isDirtyField, setIsDirtyField] = React.useState(false);
  const [isValid, setIsValid] = React.useState(false);

  const handleChange = (event) => {
    const val = event.target.value;
   // console.log(event);
    let count = 0;
    for (let i = 0; i < val.length; i++) {
      if (val.charAt(i) in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]) count++;
    }
    var isValid = count === 11 ? true : false;
    setPhoneNumber(val);
    setIsValid(isValid);
    var number = props.array;
    props.handleChange(val, isValid, number);
  };

  const handleChangeEmail = (event) => {
    const val = event.target.value;
    //console.log(event);

    //var isValid = false;

    var isValid = (/.+@.+\.[A-Za-z]+$/.test(val)) ? true : false

    /*if (/^[a-z0-9_\.-]+$/.test(val)) isValid = true;
    if (/^[a-z0-9_\.-]+@$/.test(val)) isValid = true;
    if (/^[a-z0-9_\.-]+@[a-z0-9-]+$/.test(val)) isValid = true;
    if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.$/.test(val)) isValid = true;
    if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}$/.test(val)) isValid = true;
    if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}\.$/.test(val)) isValid = true;
    if (/^[a-z0-9_\.-]+@[a-z0-9-]+\.[a-z]{1,4}\.[a-z]{1,4}$/.test(val)) isValid = true;*/

    setEmailNumber(val);
    setIsValid(isValid);
    var number = props.array;
    props.handleChange(val, isValid, number);
  };


  const handleChangeWagonNumber = (event) => {
    const val = event.target.value;
    //console.log(event);
    let count = 0;
    for (let i = 0; i < val.length; i++) {
      if (val.charAt(i) in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]) count++;
    }
    var isValid = count === 8 ? true : false;
    setWagonNumber(val);
    setIsValid(isValid);
    var number = props.array;
    props.handleChange(val, isValid, number);
  };


  return (
    <>
      <FormControl variant="outlined" sx={{ height: "55px" }}>
        <InputLabel shrink htmlFor="text-mask-input">
          {props.helperText}
        </InputLabel>
        <OutlinedInput
          sx={{ height: "55px", 
          customInputLabel: {
            "& legend": {
              visibility: "visible",
            },
          },
          }}
          variant="outlined"
          //helperText={props.helperText}
          placeholder={props.placeholder}
          error={isDirtyField && !isValid}
          onChange={
            props?.fieldName === "Phone" ? handleChange : (props?.fieldName === "Email" ? handleChangeEmail : handleChangeWagonNumber)
          }
          onBlur={() => setIsDirtyField(true)}
          name="phone"
          label={props.helperText}
          fullWidth={true}
          size={"small"}
          value={props.objectPhone}
          // InputLabelProps={{
          //   shrink: true,
          // }}
          inputComponent={
            props?.fieldName === "Phone" ? TextMaskCustom : (props?.fieldName === "Email" ? TextMaskCustomEmail : TextMaskCustomWagonNumber)
          }
          autoFocus
          //classes={{ notchedOutline: classes.customInputLabel }}
          notched
          aria-describedby="base-name-helper-text"
          inputProps={{
            "aria-label": "weight",
          }}
        />
      </FormControl>
    </>
  );
}

